<template>
  <div>
    <el-button class="button" type="primary" @click="getDefault()"
      >查询</el-button
    >
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <div class="search-left-top">
        <el-form-item label="单位名称：">
          <el-input v-model="formInline.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="IP地址：">
          <el-input v-model="formInline.ipAddress"></el-input>
        </el-form-item> -->
        <el-form-item label="状态：">
          <el-select v-model="formInline.status">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送时间：">
          <el-date-picker
            v-model="formInline.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateChange()"
          >
          </el-date-picker>
        </el-form-item>
      </div>
    </el-form>
    <!-- 标题 -->
    <div class="title">
      <div>IP授权列表</div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button type="primary" @click="add">新增</el-button>
        <el-upload
          class="upload"
          action=""
          :http-request="httpRequest"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :accept="acceptedFileTypes"
        >
          <el-button type="primary">导入</el-button>
          <el-button type="primary" @click="downFile">下载模板文件</el-button>
        </el-upload>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="单位名称" align="center">
      </el-table-column>
      <el-table-column prop="rights_str" label="产品授权" align="center">
      </el-table-column>
      <el-table-column label="授权起止时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.start_time }}</div>
          <div>{{ scope.row.end_time }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">已停用</span>
          <span v-if="scope.row.status == 1">已启用</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 0"
            type="text"
            @click="handleStatus(scope.row)"
          >
            启用
          </el-button>
          <el-button v-else type="text" @click="handleStatus(scope.row)">
            停用
          </el-button>
          <el-button type="text" @click="checkIp(scope.row)">IP地址</el-button>
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 校园网编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="editForm" label-width="180px">
        <el-form-item label="单位名称：">
          <el-input type="text" v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="产品授权：">
          <el-checkbox
            v-model="selectAll1"
            @change="handleSelectAll1"
            style="font-weight: 600 !important;color: #333 !important;"
          >
            资源权限
          </el-checkbox>
          <el-checkbox-group v-model="selectedOptions1">
            <el-checkbox
              v-for="option in options1"
              :label="option.value"
              :key="option.value"
            >
              {{ option.label }}
            </el-checkbox>
          </el-checkbox-group>

          <el-checkbox
            v-model="selectAll2"
            @change="handleSelectAll2"
            style="font-weight: 600 !important;color: #333 !important;"
          >
            功能权限
          </el-checkbox>
          <el-checkbox-group v-model="selectedOptions2">
            <el-checkbox
              v-for="option in options2"
              :label="option.value"
              :key="option.value"
            >
              {{ option.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="生效时间：">
          <el-date-picker
            v-model="editForm.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="change()"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="editForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- IP地址编辑弹出框 -->
    <el-dialog
      :visible.sync="editIpVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editIpTitle"
      center
    >
      <el-form ref="ruleForm" :model="editIpForm" label-width="180px">
        <el-form-item label="单位名称：">
          <el-input type="text" v-model="editIpForm.name"></el-input>
        </el-form-item>
        <el-form-item label="IP地址列表：">
          <el-input
            type="textarea"
            placeholder="每个IP段请用换行符分开 例：
192.0.0.1-192.0.0.99
193.0.0.1-193.0.0.99"
            v-model="editIpForm.ip_str"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveIpEdit('ruleForm')">
          保 存
        </el-button>
        <el-button type="primary" @click="editIpVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import http from "../../../api/zkApiConfig";
export default {
  data() {
    return {
      selectAll1: false,
      selectAll2: false,
      selectedOptions1: [],
      selectedOptions2: [],
      options1: [
        { label: "基本古籍库", value: "base_books" },
        { label: "域外古籍库", value: "yw_books" },
        { label: "孤本古籍库", value: "wq_books" },
        { label: "医案库", value: "zsk_case" },
        { label: "方剂库", value: "zsk_fang" },
      ],
      options2: [
        { label: "同义词搜索", value: "search_tong" },
        { label: "专业词典", value: "dictionary_high" },
      ],
      send_date: "",
      my_file: "",
      acceptedFileTypes: ".xlsx",
      id: "",
      is_edit: false,
      editVisible: false,
      editIpVisible: false,
      editTitle: "校园网详情页",
      editIpTitle: "IP地址详情页",
      loading: false,
      formInline: {
        type: "",
        status: "",
      },
      // IP
      editIpForm: {},
      // 校园网
      editForm: {},
      tableData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      status: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "已停用",
        },
        {
          value: 1,
          label: "已启用",
        },
      ],
      pickerOptions: {
        disabledDate: (time) => {
          const oneWeekLater = new Date();
          oneWeekLater.setDate(oneWeekLater.getDate() + 7);
          // 如果时间小于当前时间一周后的日期，则禁用选择
          return time.getTime() < oneWeekLater.getTime();
        },
      },
    };
  },
  mounted() {
    this.getDefault();
    this.updateSelectAll1();
    this.updateSelectAll2();
  },
  watch: {
    selectedOptions1() {
      this.updateSelectAll1();
    },
    selectedOptions2() {
      this.updateSelectAll2();
    },
  },
  methods: {
    handleSelectAll1(checked) {
      if (checked) {
        this.selectedOptions1 = this.options1.map((option) => option.value);
        this.selectAll1 = true;
      } else {
        this.selectedOptions1 = [];
        this.selectAll1 = false;
      }
    },
    handleSelectAll2(checked) {
      if (checked) {
        this.selectedOptions2 = this.options2.map((option) => option.value);
        this.selectAll2 = true;
      } else {
        this.selectedOptions2 = [];
        this.selectAll2 = false;
      }
    },
    updateSelectAll1() {
      if (this.selectedOptions1.length === this.options1.length) {
        this.selectAll1 = true;
      } else {
        this.selectAll1 = false;
      }
    },
    updateSelectAll2() {
      if (this.selectedOptions2.length === this.options2.length) {
        this.selectAll2 = true;
      } else {
        this.selectAll2 = false;
      }
    },
    submitData() {
      const selectedValues1 = this.options1
        .filter((option) => this.selectedOptions1.includes(option.value))
        .map((option) => option.value);
      const selectedValues2 = this.options2
        .filter((option) => this.selectedOptions2.includes(option.value))
        .map((option) => option.value);
      const selectedValues = selectedValues1.concat(selectedValues2);
      console.log(selectedValues, "selectedValues");
      this.editForm.rights = selectedValues.join(","); // 使用 join 方法将数组转换为字符串
      // 将选中的 value 值提交给后端
      // 替换成实际的提交数据方法
    },
    // 发送时间
    dateChange() {
      this.formInline.start_time = this.formInline.date[0];
      this.formInline.end_time = this.formInline.date[1];
    },
    // 授权时间
    change() {
      const startDate = this.editForm.date[0];
      const oneWeekLater = new Date();
      oneWeekLater.setDate(oneWeekLater.getDate() + 7);
      if (startDate && startDate > oneWeekLater) {
        this.editForm.date[0] = oneWeekLater;
      }
      console.log(this.editForm.date, "this.editForm.date");
      this.editForm.start_time = this.editForm.date[0];
      this.editForm.end_time = this.editForm.date[1];
    },
    isStartDate(time) {
      const startDate = this.editForm.date[0];
      return (
        startDate &&
        time.getFullYear() === startDate.getFullYear() &&
        time.getMonth() === startDate.getMonth() &&
        time.getDate() === startDate.getDate()
      );
    },
    // 下载模版文件
    downFile() {
      window.location.href =
        "https://haiwei-public.oss-cn-shanghai.aliyuncs.com/template/205fff17576b513531225c95bb1f4306.xlsx";
    },
    //验证文件类型
    beforeAvatarUpload(file) {
      const isXls =
        file.type === "application/vnd.ms-excel"
          ? true
          : file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ? true
          : false;
      if (!isXls) {
        this.$message.error("上传的文件只能是xlsx格式!");
      }
      return isXls;
    },
    // ---------------导入
    httpRequest(param) {
      let formData = new FormData();
      formData.append("my_file", param.file);
      http.post("/admin/institutions/import", formData).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("已导入");
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查询列表
    getDefault() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        page_size: this.page_size,
        name: this.formInline.name,
        status: this.formInline.status,
        start_time: this.formInline.start_time,
        end_time: this.formInline.end_time,
      };
      http.get("/admin/institutions/list", { params: params }).then((res) => {
        if (res.data.status_code == 200) {
          this.tableData = res.data.data.data;
          this.currentPage = Number(res.data.data.current_page);
          this.totalPages = res.data.data.last_page;
          this.pageTotal = this.totalPages * this.page_size;
          this.loading = false;
        }
      });
    },
    // 新增
    add() {
      this.is_edit = false;
      this.editForm = {};
      this.editVisible = true;
    },
    // 编辑
    edit(row) {
      this.id = row.id;
      http.get("/admin/institutions/" + row.id).then((res) => {
        if (res.data.status_code == 200) {
          this.editForm = res.data.data;
          this.$set(this.editForm, "date", [
            res.data.data.start_time,
            res.data.data.end_time,
          ]);
          // 清空已选中的选项值
          this.selectedOptions1 = [];
          this.selectedOptions2 = [];
          // 根据接口返回的已选中的选项值，判断选项属于哪个数组，并更新 selectedOptions1 和 selectedOptions2 数组
          if (this.editForm.rights_array != null) {
            for (const option of this.editForm.rights_array) {
              if (this.options1.some((item) => item.value === option)) {
                this.selectedOptions1.push(option);
              } else if (this.options2.some((item) => item.value === option)) {
                this.selectedOptions2.push(option);
              }
            }
          }
          // 根据已选中的选项值，更新全选状态
          this.updateSelectAll1();
          this.updateSelectAll2();
        }
      });
      this.is_edit = true;
      this.editVisible = true;
    },
    // IP地址
    checkIp(row) {
      this.editIpForm = row;
      this.id = row.id;
      http.get("/admin/institutions/" + row.id).then((res) => {
        if (res.data.status_code == 200) {
          this.editIpForm = res.data.data;
        }
      });
      this.editIpVisible = true;
    },
    // IP编辑
    saveIpEdit() {
      let params = {
        // name: this.editIpForm.name,
        ip: this.editIpForm.ip_str,
      };
      // console.log(params,"1");
      http
        .put("admin/institutions/ip/edit/" + this.editIpForm.id, params)
        .then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("修改成功");
            this.getDefault();
            this.editIpVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 生效/停用
    handleStatus(row) {
      console.log(row, "row");
      if (row.status == 0) {
        let that = this;
        that
          .$confirm("确定要启用吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/institutions/status/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已启用");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        let that = this;
        that
          .$confirm("确定要停用吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/institutions/status/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已生效");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/institutions/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 提交
    saveEdit() {
      this.submitData();
      if (this.is_edit == true) {
        let params = {
          name: this.editForm.name,
          rights: this.editForm.rights,
          start_time: this.editForm.start_time,
          end_time: this.editForm.end_time,
          remark: this.editForm.remark,
        };
        http.put("admin/institutions/edit/" + this.id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("修改成功");
            this.getDefault();
            this.editVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = {
          name: this.editForm.name,
          rights: this.editForm.rights,
          start_time: this.editForm.start_time,
          end_time: this.editForm.end_time,
          remark: this.editForm.remark,
        };
        http.post("/admin/institutions/add", params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("新增成功");
            this.getDefault();
            this.editVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.upload {
  height: 32px;
  margin-left: 10px;
}
/deep/.el-textarea__inner {
  min-height: 70px !important;
}
/deep/.el-upload--text {
  background: none !important;
}
/deep/.el-upload {
  height: 32px;
  border: none;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
